import { Nullable } from "src/shared/utils/typescript";

export type AccountProfileNames = {
  displayName: string;
  legalName: string;
};

export const buildAccountProfileNames = (
  legalName: Nullable<string> | undefined,
  preferredName: Nullable<string> | undefined
): AccountProfileNames => {
  const normalizedLegalName = legalName?.trim() ?? "";
  const normalizedPreferredName = preferredName?.trim() ?? "";

  return {
    displayName: normalizedPreferredName || normalizedLegalName,
    legalName: normalizedLegalName,
  };
};
